import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IdentityFacade } from '../application-services/identity.facade';
import { readStoredTokenRaw } from '@domains/shared/domain/utils/auth-storage';


// Note: these are only the initial imports. Add more as needed.

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public identityFacade: IdentityFacade) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = getToken();
    if (token && !isLoginRequest(request.url)) {
      request = request.clone({
        setHeaders: {Authorization: `Bearer ${token}`}
      });
    }
    return next.handle(request);
  }
}

/**
 * Přihlašovací endpoint odchází bez tokenu.
 *
 * Porovnává se konec cesty, ne podřetězec kdekoli v URL. Některé endpointy nesou
 * e-mail přímo v adrese (`/backoffice/User/Check/{email}`), takže uživatel jako
 * login@firma.cz dřív o hlavičku Authorization tiše přišel — server odpověděl 401
 * a error interceptor ho odhlásil uprostřed importu.
 */
export function isLoginRequest(url: string): boolean {
  const path = url.split(/[?#]/)[0].replace(/\/+$/, '');

  return path.toLowerCase().endsWith('/auth/login');
}

/**
 * Token této záložky — v záložce náhledu kurzu token náhledového studenta ze
 * `sessionStorage`, jinak běžné přihlášení (`auth-storage.ts`, EL-2357).
 */
function getToken(): string | undefined {
  let token = undefined;
  const rawJSON = readStoredTokenRaw();
  if (rawJSON !== null) {
    token = JSON.parse(rawJSON);
  }
  return token;
}
